import { createSelector } from '@reduxjs/toolkit';
import { getNodeId as getAppNodeId } from '../app/selectors';
import { Favorite, MAX_PANEL_ITEMS } from './model';
import { getStore } from '../../models/rootSelector';
export const getFavorite = createSelector(getStore, (s) => s.favorite);
export const getList = createSelector(getFavorite, (x) => x.list);
export const getIsLoading = createSelector(getFavorite, (f) => f.isLoading);
export const getRenamingId = createSelector(getFavorite, (f) => f.renamingId);
export const getRenamingPlace = createSelector(getFavorite, (f) => f.renamingPlace);
export const getRenamingText = createSelector(getFavorite, (f) => f.renamingText);
export const getRenamingIdsInProgress = createSelector(getFavorite, (f) => f.renamingIdsInProgress);
export const getFavoriteByNodeId = createSelector([getList], (list) => {
  const result: Record<React.Key, Favorite> = {};
  list.forEach((favorite) => {
    result[favorite.node_id] = favorite;
  });
  return result;
});

export const getFavoriteByBaseId = createSelector([getList], (list) => {
  const result: Record<React.Key, Favorite> = {};
  list.forEach((favorite) => {
    result[favorite.node_id] = favorite;
  });
  return result;
});

export const getFavoriteById = createSelector([getList], (list) => {
  const result: Record<React.Key, Favorite> = {};
  list.forEach((favorite) => {
    result[favorite.id] = favorite;
  });
  return result;
});

export const getPanelItems = createSelector([getList], (list) => list.slice(0, MAX_PANEL_ITEMS));

export const getCurrentBaseId = createSelector(
  [getFavoriteByBaseId, getAppNodeId],
  (items, appNodeId) => {
    if (!appNodeId) return null;
    const node = items[appNodeId];
    return node ? appNodeId : null;
  },
);

export const getIsToggleOn = createSelector(getCurrentBaseId, (currentBaseId) =>
  Boolean(currentBaseId),
);

export const getBaseIdsInProgress = createSelector(getFavorite, (f) => f.baseIdsInProgress);

export const getTableData = getList;
